import {put, takeLatest, call} from 'redux-saga/effects';
import * as reportService from "../../../services/reportService";
import {
    GET_DAYOFWEEK_REPORT,
    GET_DAYOFWEEK_REPORT_SUCCESS,
    GET_DAYOFWEEK_REPORT_ERROR,
}
    from "../../actions/report"

function* getDayOfWeekReportSaga(action) {
    try {
       const data  = yield call(reportService.GetDayOfWeekReport,action.payload)
       yield put({
        type: GET_DAYOFWEEK_REPORT_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_DAYOFWEEK_REPORT_ERROR,error: error.data
        })
    }
}


export function* getDayOfWeekReportSagaWatcher() {
    yield takeLatest(GET_DAYOFWEEK_REPORT, getDayOfWeekReportSaga)
}